const relations = {
	description:
		"Here you can create relations and link products/services to these relations. A relation can be a customer of yours or a department. This gives you an overview of which products belong to which relation. Also, the details of a relation can be used for example with domain names and SSL certificates.",
	dialog_add: {
		description: "Create a new relation",
		input_description: {
			label: "Relation description",
			placeholder: "Optionally give the relation a description",
		},
		input_name: {
			label: "Relation name",
			placeholder: "Give the relation a name",
		},
		messages: {
			success: "Relation <strong>{{relation_name}}</strong> has been successfully added!",
		},
		radio_is_business: {
			label: "Type of relation",
			values: {
				business: "Business",
				private: "Private",
			},
		},
		title: "Add new relation",
	},
	item: {
		add: {
			description: "Select a relation to link to product <strong>{{service_name}}</strong/>",
			input_label: "Select a relation",
			title: "Add product relation",
		},
		delete: {
			description:
				"Are you sure you want to remove the link with relation <strong>{{relation}}</strong> for product <strong>{{service_name}}</strong>?",
			not_found: "We could not find the relation. Please try again later.",
			title: "Unlink product from relation",
		},
	},
	overview_table: {
		empty: "Empty",
		head: {
			description: "Description",
			id: "ID",
			name: "Name",
			type: "Type of relation",
		},
		relation_types: {
			business: "Business",
			private: "Private",
		},
	},
	service_type_list: {
		dadup: {
			no_dadup_connected: "This relationship has no linked Dadup accounts.",
			title: "daDup Storage",
		},
		domains: {
			no_domains_connected: "This relation has no connected domains.",
			title: "Domain names",
		},
		pbs: {
			is_free_version: "Free version",
			no_pbs_connected: "This relation has no Tuxis PBS datastores.",
			title: "Tuxis PBS",
		},
		qemu: {
			dialog_add: {
				description: "Select one or more VPSs here to link to the relation.",
				relation_overwrite_warning:
					"Attention! This will be disconnected from relation <strong>{{linked_relation_name}}</strong>.",
				title: "Link VPSs to relation",
			},
			dialog_add_select_multiple: {
				description: "Select one or more VPSs here to link to the relation.",
				empty: "There are no VPSs available to link to the relation.",
				linked_relation: "Currently linked to this relation",
				title: "Select available VPSs",
			},
			no_qemus_added: "This relation has no connected VPSs.",
			title: "VPSs",
		},
	},
	single: {
		delete: {
			button: "Delete relation",
			description:
				"Are you sure you want to delete relation <strong>{{relation}}</strong>? The linked services will be disconnected.",
			status_message: {
				success: "Relation successfully deleted",
			},
			title: "Delete relation",
		},
		domain_details: {
			address_details: {
				country: "Country",
				title: "Address details",
			},
			company_details: {
				title: "Company details",
			},
			contact_details: {
				title: "Personal details",
			},
			description: "In this section, you can change the domain details of the relation.",
			status_message: {
				success: "Domain details of relation successfully adjusted",
			},
			title: "Domain details",
			trademark_details: {
				title: "Trademark information (optional)",
			},
			warning_message: {
				cannot_edit:
					"Please note! The fields 'First name' 'Middle name' 'Last name' are not editable after saving. Please make sure the correct data is here, if you still want to edit it you need to create a new relation.",
				cannot_edit_register_company:
					"Please note! The 'Company name' fields are not editable after saving. Please make sure that the correct data is here.",
				cannot_edit_register_personal:
					"Please note! The fields 'First name' 'Middle name' 'Last name' are not editable after saving. Please make sure the correct data is here.",
				cannot_edit2:
					"Please note! The 'Company name' fields are not editable after saving. Please make sure that the correct data is here, if you still want to modify it you need to create a new relation",
				message:
					"Notice! When saving this form, the information entered is applied to all domains linked to this relationship.",
			},
		},
		navbar: {
			information: "Information",
			overview: "Products & Services",
		},
		relation_details: {
			description: "In this section, you can change the name and description of the relation.",
			status_message: {
				success: "Relation details successfully adjusted",
			},
			title: "Relation details",
		},
		title: "Relation",
	},
	title: "Relations",
};

export default relations;
